<template>
    <ModalContent>
        <Title>카톡/문자발송</Title>

        <TimeInfo>
            <TimeItem>알림톡: 20원</TimeItem>
            <TimeDivider>|</TimeDivider>
            <TimeItem>친구톡: 38원</TimeItem>
            <TimeDivider>|</TimeDivider>
            <TimeItem>문자단문(45자): 35원</TimeItem>
            <TimeDivider>|</TimeDivider>
            <TimeItem>문자장문(1,000자): 70원</TimeItem>
        </TimeInfo>

        <ContentWrapper>
            <InfoRow>
                <label>수급자성함:</label>
                <div class="value-box">{{ name || '' }}</div>
                <label>인정번호:</label>
                <div class="value-box">{{ number || '' }}</div>
            </InfoRow>

            <InfoRow>
                <label>보호자성함:</label>
                <div class="value-box">{{ guardname || '' }}</div>
                <label>연락처1:</label>
                <div class="value-box">{{ phone1 || '' }}</div>
                <label>연락처2:</label>
                <div class="value-box">{{ phone2 || '' }}</div>
            </InfoRow>
        </ContentWrapper>

        <PhoneWrapper>
            <InfoRow>
                <label>발신번호:</label>
                <select v-model="senderNumber">
                    <option value="선택">선택</option>
                    <option value="01022890656">01022890656</option>
                </select>
                <label>수신번호:</label>
                <input type="text" v-model="receiverNumber" />
            </InfoRow>
            <MessageContentContainer>
                <MessageTextareaWrapper>
                    <ModernTextarea v-model="content" placeholder="카카오톡 발송 실패시 대체문자가 발송됩니다."
                        :class="{ 'over-limit': isOverByteLimit }" @input="updateByteLength" />
                    <ByteCounter :class="{ 'warning': isOverByteLimit }">
                        {{ byteLength }} / 1,000 자
                    </ByteCounter>
                </MessageTextareaWrapper>
            </MessageContentContainer>
            <ButtonGroup>
                <KakaoButton @click="sendKakao">카카오톡 발송</KakaoButton>
                <MessageButton @click="sendSMS">문자 발송</MessageButton>
                <AlimtalkButton>알림톡 발송</AlimtalkButton>
                <BillButton>계약서 발송</BillButton>
            </ButtonGroup>
        </PhoneWrapper>

        <CloseButton @click="closeModal">취소</CloseButton>
    </ModalContent>
</template>

<script>
import * as SmsModalCss from '@/assets/styles/order/modal/SmsModalCss.js';

export default {
    name: 'SmsModal',

    components: {
        ...SmsModalCss
    },

    props: {
        name: {
            type: String,
            default: ''
        },
        number: {
            type: String,
            default: ''
        },
        guardname: {
            type: String,
            default: ''
        },
        phone1: {
            type: String,
            default: ''
        },
        phone2: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            messageContent: '',
            senderNumber: '선택',
            receiverNumber: '',
            byteLength: 0
        };
    },

    computed: {
        isOverByteLimit() {
            return this.byteLength > 90;
        }
    },

    methods: {
        getByteLength(str) {
            if (!str) return 0;

            let byte = 0;
            for (let i = 0; i < str.length; i++) {
                const charCode = str.charCodeAt(i);
                if (charCode > 127) {
                    byte += 2; // 한글, 한자, 특수문자 등
                } else {
                    byte += 1; // 영문, 숫자, 공백 등
                }
            }
            return byte;
        },
        updateByteLength() {
            this.byteLength = this.getByteLength(this.messageContent);
        },
        applyTemplate(template) {
            this.messageContent = template.content;
            this.updateByteLength();
        },
        async sendKakao() {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.popbill}/popbill/kakao/listATSTemplate`, {
                    params: {
                        CorpNum: '1681102066', // 팝빌회원 사업자번호
                        UserID: 'wjdwhdrkr2', // 발신번호 (팝빌에 등록된 번호만 사용 가능)
                    }
                });

                console.log(response.data);
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    title: '전송 실패',
                    text: "알림톡 템플릿 목록 확인 실패",
                    icon: 'error',
                    confirmButtonText: '확인'
                });

                return null;
            }
        },
        async sendFriendTalk() {
            try {
                const response = await this.$axios.post(`${this.$apiUrls.popbill}/popbill/kakao/sendFTS`, {
                    params: {
                        CorpNum: '1681102066',
                        PlusFriendID: 'ass3839@naver.com',
                        Sender: '01023515847',
                        content: '친구톡 내용입니다.',
                        receiver: '01049189007',
                    }
                });

                console.log(response.data);
                return response.data;
            } catch (error) {
                console.error('친구톡 전송 실패:', error);
                return null;
            }
        },
        async sendSMS() {
            try {
                // 1. 필수 입력값 검증
                if (!this.receiverNumber) {
                    this.$swal.fire({
                        title: '전송 실패',
                        text: '수신번호를 입력해주세요.',
                        icon: 'warning',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                if (!this.content || this.content.trim() === '') {
                    this.$swal.fire({
                        title: '전송 실패',
                        text: '메시지 내용을 입력해주세요.',
                        icon: 'warning',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                // 2. 발신번호 검증
                if (this.senderNumber === '선택' || !this.senderNumber) {
                    this.$swal.fire({
                        title: '전송 실패',
                        text: '발신번호를 선택해주세요.',
                        icon: 'warning',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                this.$swal.fire({
                    title: '전송 중...',
                    text: '메시지를 전송하고 있습니다.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                const response = await this.$axios.post(`${this.$apiUrls.popbill}/popbill/sms/sendSMS`, {
                    params: {
                        CorpNum: '1681102066', // 팝빌회원 사업자번호
                        Sender: '01023515847', // 발신번호 (팝빌에 등록된 번호만 사용 가능)
                        SenderName: this.senderName || '정종각', // 발신자명
                        Receiver: this.receiverNumber, // 수신번호
                        ReceiverName: this.name || '', // 수신자명
                        Content: this.content, // 메시지 내용
                        UserID: 'wjdwhdrkr2', // 팝빌회원 아이디
                    }
                });

                await this.$swal.close();

                if (response.data && response.data.receiptNum) {
                    this.$swal.fire({
                        title: '전송 완료',
                        text: '메시지가 성공적으로 전송되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인'
                    });

                    return response.data.receiptNum;
                } else {
                    throw new Error('메시지 전송에 실패했습니다.');
                }
            } catch (error) {
                await this.$swal.close();

                console.error('SMS 전송 실패:', error);

                let errorMessage = '메시지 전송 중 오류가 발생했습니다.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                this.$swal.fire({
                    title: '전송 실패',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: '확인'
                });

                return null;
            }
        },
        closeModal() {
            this.$emit('close');
        }
    },

    mounted() {
        // 초기 바이트 길이 계산
        this.updateByteLength();

        // 수신번호 자동 설정 (phone1이 있으면 사용)
        if (this.phone1) {
            this.receiverNumber = this.phone1;
        }
    },
}
</script>
